import axios from 'axios'
import { ProductModifier } from '@busdk/storefront-service/dist/models/enums';

/**
 * Getting prefill data is handled in two different locations at the moment:
 * - StorefrontQuery
 * - TanModal
 * 
 * @param transactionId 
 * @param tanValue 
 */
export async function getPrefillData({
    transactionId,
    token,
    tanValue,
} : {
    transactionId: string;
    token?: string;
    tanValue?: string;
}) {
    let url = `${process.env.REACT_APP_API_BASE_URL}/prefill/${process.env.REACT_APP_COUNTRY}/${process.env.REACT_APP_BRAND}/${process.env.REACT_APP_ENTRYPOINT}/${ProductModifier.USED}/${transactionId}`;
    if (token) {
        url = url.concat(`?token=${token}`);
    } else if (tanValue) {
        url = url.concat(`?tan=${tanValue}`)
    }

    return axios.get(url, {})
}
